
import React, { useState, useEffect, useMemo } from "react";
import { useQuery, useMutation } from 'react-fetching-library';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import Title from '../components/Title';
import Table from '../components/Table';
import ConfirmationModal from "../components/ConfirmationModal";
import { fetchContractList, resendContract } from "../api/actions/contracts";
import { fetchSubcriptions, cancelSubscription } from "../api/actions/profile";
import { useModalsState } from '../context/modals';
import useDebounce from '../hooks/useDebounce';
import useQueryParams from '../hooks/useQuery';

import { truncate, downloadFile, capitalize, getPrice } from '../utils';

function ContractsTableContainer({ className }) {
  const { t } = useTranslation('common')
  // const { templateId } = useParams();
  // const query = useQueryParams()
  const matched = useRouteMatch()
  const history = useHistory();
  const modalsState = useModalsState();
  
  // const [currentPage, setCurrentPage] = useState(1);
  const [hasError, setHasError] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isResendOpen, setIsResendOpen] = useState(false)
  // const [search, setSearch] = useState(query.get('search') ?? '');
  const [currentSubscription, setCurrentSubscription] = useState({})
  const [subscriptionList, setSubscriptionList] = useState([]);
  // const debouncedSearch = useDebounce(search, 500);

  const subscriptionListAction = useMemo(() => fetchSubcriptions({
    // page: currentPage,
    // perPage: 8,
    // search: debouncedSearch,
    // templateId
  }), [])
  const { loading, payload: listPayload  = {} , error } = useQuery(subscriptionListAction);
  const { payload, loading: canceling, mutate, reset } = useMutation(cancelSubscription)

  
  // const handleSearch = (evt) => {
  //   const value = evt?.target?.value ?? '';
  //   setCurrentPage(1);
  //   setSearch(value)
  //   setIsSearching(true)
  //   history.replace(`${matched.url}?search=${value}`)
  // }

  const goBack = () => {
      history.goBack()
  }

  // const handleNextPage = () => {
  //   const newPage = Math.min(currentPage + 1, listPayload.numPages);
  //   setCurrentPage(newPage)
  // }

  // const handlePrevPage = () => {
  //   const newPage = Math.max(currentPage - 1, 1);
  //   setCurrentPage(newPage)
  // }

  const handleResendEmail = async () => {
    const {error: mutateError} = await mutate({
                                              id: currentSubscription.id,
                                            });
    if (mutateError) {
      setHasError(true)
    }                             
  }

  const toggleResend = (subscription) => {
    setIsResendOpen(isOpen => !isOpen)
    setCurrentSubscription(subscription)
  }

  useEffect(
    () => {
      setIsSearching(false);
      setSubscriptionList(listPayload?.data ?? []);
    },
    [listPayload]
  );

  useEffect(() => {
    if (payload?.success) {
      setIsResendOpen(false)
      toast.info(t('successMessages.cancelSubscription', {name: capitalize(currentSubscription.name)}), {autoClose: 3000})
      setSubscriptionList(list => list.filter(el => el.id !== currentSubscription.id) )
    } else if ((payload?.error) || hasError) {
      const message =  (payload?.error?.length) ? 
        t(`errorMessages.${payload.error}`, {autoClose: 3000})
        : t('errorMessages.generalError', {autoClose: 3000 })
      toast.error(message)
      setHasError(false)
    }
    reset()
  }, [payload, hasError, t, currentSubscription, reset])

  return (
      <div className={className}>  
          <Title 
            className="mb-4"
            button 
            buttonProps={{
              text: t('actions.goBack'),
              color: 'light',
              onClick: goBack,
            }}
          >
            {t('subscription', { count: 2 })}
          </Title>
          <Table 
            isLoading={loading || isSearching}
            hasError={error}
            itemId="id"
            EmptyTableProps={{
              primary: t('noSubcriptions'),
              secondary: t('noResults')
            }}
            columns={[
            {
              header: t('name'),
              key: 'name',
            },
            {
              header: t('type'),
              key: 'interval',
              render: (subscription) => {
                return <span>{t(`interval.${subscription.interval}`)}</span>
              }
            },
            {
              header: t('price'),
              key: 'amount',
              render: (subscription) => {
                return <span>{getPrice(subscription.amount, subscription.currency, true)}</span>
              }
            }
          ]}
          data={subscriptionList}
          pagination={false}
          actions={[
            {
              key: 'id',
              icon: 'times',
              label: t('actions.cancel'),
              onClick: toggleResend
            }
          ]}
        />
      <ConfirmationModal  
          onCancel={() => toggleResend({})} 
          isOpen={isResendOpen}
          isLoading={canceling}
          onConfirm={handleResendEmail}
          confirmText={t('actions.cancel')}
          cancelText={t('actions.goBack')}  
          QuestionComponent={Question}
          QuestionComponentProps={{
            question: 'Estas seguro que quieres cancelar la subscripcion: ',
            participantName: currentSubscription.name,
          }}
          simple
      />   
      </div>
  ) 
}

export default ContractsTableContainer;

function Question({question, participantName}) {
return(<span>
  {question}
  <strong className='text-capitalize font-weight-bolder'>{participantName}</strong>{'?'}
</span>)
}